import React from "react";
import { Flipped, Flipper } from "react-flip-toolkit";

import "../../styles/FlipClock.css";

const FlipUnit = ({ flipId, number }) => (
  <Flipped flipId={flipId}>
    <span className="flip-clock__unit">{number}</span>
  </Flipped>
);

const FlipClock = ({ city, time, className = "" }) => {
  const [clockTime = "--:--", period = ""] = String(time).trim().split(/\s+/);
  const [rawHours = "--", rawMinutes = "--"] = clockTime.split(":");
  const hours = rawHours.padStart(2, "0").slice(-2);
  const minutes = rawMinutes.padStart(2, "0").slice(-2);
  const clockId = city.toLowerCase().replace(/[^a-z0-9]+/g, "-");

  return (
    <section className={`flip-clock ${className}`.trim()} aria-label={`${city} : ${time}`}>
      <h3 className="flip-clock__city">{city}</h3>

      <Flipper flipKey={time} spring="stiff">
        <div className="flip-clock__display" aria-hidden="true">
          <FlipUnit flipId={`${clockId}-hour-tens`} number={hours[0]} />
          <FlipUnit flipId={`${clockId}-hour-units`} number={hours[1]} />
          <span className="flip-clock__separator">:</span>
          <FlipUnit flipId={`${clockId}-minute-tens`} number={minutes[0]} />
          <FlipUnit flipId={`${clockId}-minute-units`} number={minutes[1]} />
          {period && <span className="flip-clock__period">{period}</span>}
        </div>
      </Flipper>
    </section>
  );
};

export default FlipClock;
